import React from "react";
import { BsEnvelope, BsLinkedin, BsPhone, BsWhatsapp } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaSkype } from "react-icons/fa";

const HeaderSocials = () => {
  const handleCall = () => {
    window.location.href = "tel:+923355590926"; // replace with your phone number
  };

  const handleChat = () => {
    window.location.href = "https://wa.me/+923355590926"; // replace with the phone number you want to chat with
  };

  return (
    <div className="header__socials">
      <div onClick={handleCall} target="_blank" rel="noreferrer">
        <BsPhone />
      </div>
      <a
        href="mailto:mianyousafzubair@gmail.com"
        target="_blank"
        rel="noreferrer"
      >
        <BsEnvelope />
      </a>
      <a
        href="https://www.linkedin.com/in/mian-yousaf-zubair-225763211/"
        target="_blank"
        rel="noreferrer"
      >
        <BsLinkedin />
      </a>
      <div onClick={handleChat} target="_blank" rel="noreferrer">
        <BsWhatsapp />
      </div>
      <a
        href="https://github.com/Yousafzubair991"
        target="_blank"
        rel="noreferrer"
      >
        <FaGithub />
      </a>
      <a
        href="https://join.skype.com/invite/CA2V6OI0hvWl"
        target="_blank"
        rel="noreferrer"
      >
        <FaSkype />
      </a>
    </div>
  );
};

export default HeaderSocials;
